import { universalFetch } from 'core/fetch';
import { ANBIETER_API_PREFIX } from 'utils/enums';
import LeadsClient from './LeadsClient';

export default new LeadsClient({
  fetch: universalFetch,
  prefix: ANBIETER_API_PREFIX,
}) as unknown as {
  createContactRequest: (data: any) => Promise<any>;
};
